import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';

import { Card, CardHeader, CardContent } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import QuestionView from './QuestionView';
import { useFormContext } from '../../../hooks/useForm';
import { reorderArray } from '../../../utils/filterData';
import TextInput from '../../../components/FormInputs/TextInput';

const MAX_DESCRIPTION_LENGTH =
  Number(process.env.REACT_APP_MAX_DESCRIPTION_LENGTH) || 500;

SectionPanel.propTypes = {
  section: PropTypes.object,
  sectionsList: PropTypes.array,
  page: PropTypes.number,
  setSections: PropTypes.func,
  setPage: PropTypes.func,
  setHasSelectedSection: PropTypes.func,
  hasSelectedSection: PropTypes.bool,
};

export default function SectionPanel({
  section,
  sectionsList,
  page,
  setSections,
  setPage,
  setHasSelectedSection,
  hasSelectedSection,
}) {
  const { getSectionQuestions, updateFormData } = useFormContext();
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const [sectionQuestions, setSectionQuestions] = useState(null);
  const [description, setDescription] = useState('');

  useEffect(() => {
    const questionList = getSectionQuestions(section.id);
    setSectionQuestions(questionList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSectionQuestions, section.id]);

  useEffect(() => {
    if (section.nextSection && section.nextSection !== 'submit') {
      const nextSectionId = section.nextSection;
      const nextIndex = sectionsList.findIndex((section) => section.id === nextSectionId);
      const newSectionOrder = reorderArray(sectionsList, page, nextIndex);
      setSections(newSectionOrder.array);
      setPage(newSectionOrder.currentIndex);
      setHasSelectedSection(true);
    }
    if (section.nextSection === 'submit') {
      setHasSelectedSection(false);
    }
    if (section.nextSection === undefined) {
      setHasSelectedSection(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  const setTicketDescription = (value) => {
    setDescription(value);
    updateFormData({ ticketDescription: value });
  };
  return (
    <Card sx={{ mt: 2, boxShadow: 14 }}>
      <CardHeader
        title={`${t('pages.formPage.section')} ${section.name || ''}`}
        sx={{
          '& .MuiCardHeader-title': {
            fontSize: isSmallScreen ? '0.775rem' : {},
          },
        }}
      />
      <CardContent>
        {sectionQuestions?.map((question) => (
          <QuestionView
            key={`q${question.id}`}
            question={question}
            sectionsList={sectionsList}
            page={page}
            setSections={setSections}
            setPage={setPage}
            setHasSelectedSection={setHasSelectedSection}
            section={section}
          />
        ))}
        {section.nextSection === 'submit' && !hasSelectedSection && (
          <TextInput
            fullWidth
            multiline
            rows={3}
            value={description}
            inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
            helperText={`${description.length}/${MAX_DESCRIPTION_LENGTH}`}
            FormHelperTextProps={{ sx: { textAlign: 'right' } }}
            label={t('pages.formPage.additonalDetail')}
            sx={{
              marginTop: '1vh',
              '& .MuiInputBase-input': {
                fontSize: isSmallScreen && '0.775rem',
              },
              '& .MuiInputLabel-root': {
                fontSize: isSmallScreen && '0.775rem',
              },
            }}
            onChange={(e) =>
              setTicketDescription(e.target.value.slice(0, MAX_DESCRIPTION_LENGTH))
            }
            size={isSmallScreen ? 'small' : 'medium'}
          />
        )}
      </CardContent>
    </Card>
  );
}
